import axios from "axios";
import crypto from "crypto";

export default {
  state: {
    sessionId: null,
    applicationId: null,
  },
  getters: {
    getSessionId: (state) => state.sessionId,
    getApplicationId: (state) => state.applicationId,
  },
  mutations: {
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
    },
    setApplicationId(state, applicationId) {
      state.applicationId = applicationId;
    },
  },
  actions: {
    generateSession({ commit }) {
      commit(
        "setSessionId",
        crypto.randomBytes(50).toString("hex").slice(0, 20)
      );
    },
    addQnaDatatoStrapi({ getters }, qnaData) {
      console.log("QNA Data: ", qnaData);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.d8taos.arsconnect.com/qnas",
        headers: {
          "Content-Type": "application/json",
        },
        data: qnaData,
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addSessionDatatoStrapi({ getters }, sessionData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.d8taos.arsconnect.com/user-sessions",
        headers: {
          "Content-Type": "application/json",
        },
        data: sessionData,
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    addSpeakDatatoStrapi({ getters }, speechData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.mdcourts.arsconnect.com/speech-managers",
        headers: {
          "Content-Type": "application/json",
        },
        data: speechData,
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    addInteractionToPostgres({ getters }, actionData) {
      let date = new Date();
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://us-central1-project-bluebox.cloudfunctions.net/analyticsPostgres/analytics",
        headers: {
          "Content-Type": "application/json",
          secret_key: "4GF7JKZ9PQ2WM6TN5XB8R1VC3LQD7FHJ",
        },
        data: {
          applicationId: getters.getApplicationId,
          sessionId: getters.getSessionId,
          actionType: actionData.actionType,
          payload: actionData.actionPayload,
          timestamp: date.toISOString(),
        },
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
